// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__13SP1","buttons":"Footer_buttons__1hnRZ"};